import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Videet Mehta Loader Logo</title>
    <g>
      <g id="V" transform="translate(11.000000, 5.000000)">
        <path d="M30 30 L35 30 L39 50 L43 30 L48 30 L42 61 L36 61 L30 30 Z" fill="currentColor" />
      </g>
      <rect
        x="20"
        y="20"
        width="60"
        height="60"
        rx="8"
        ry="8"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </g>
  </svg>
);

export default IconLoader;
